// extracted by mini-css-extract-plugin
export default {"news":"news_news__jR8eD","featured":"news_featured__AjJvW","img":"news_img__7KT1c","titleFeatured":"news_titleFeatured__XdnGw"};